import * as React from 'react';
import { toast, ToastContainer as ToastContainer$2, Slide } from 'react-toastify';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import toastService from './ToastService.js';

const defaultPositionOption = toast.POSITION.BOTTOM_CENTER;
/**
 * @deprecated - use iris-ui component https://iris-ui.grandvision.io/storybook/index.html?path=/docs/components-feedback-toast--docs
 */ const ToastContainer = ()=>{
    const { getLabel  } = useIntl();
    React.useEffect(()=>toastService.init(getLabel)
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ToastContainer$2, {
        autoClose: 6000,
        closeButton: /*#__PURE__*/ React.createElement(Icon, {
            name: "close"
        }),
        position: defaultPositionOption,
        transition: Slide,
        newestOnTop: true
    });
};
var ToastContainer$1 = /*#__PURE__*/ React.memo(ToastContainer);

export { ToastContainer, ToastContainer$1 as default };
//# sourceMappingURL=ToastContainer.js.map
